import React from 'react'
import PropTypes from 'prop-types'

// Must pass in navigate, location, and NavLink. Will fail if imported here.

const Tabs = ({
  tabs,
  prevPage,
  breakpoint = 'lg',
  vertical,
  replace = false,
  navigate,
  location,
  NavLink,
  underline = false
}) => (
  <>
    <div className='row mb-4'>
      <div className={`col-12 d-none d-${breakpoint}-block`}>
        <div className={`d-flex nav nav-tabs ${vertical ? 'flex-column' : ''}`}>
          {tabs.map((d, i) => (
            <div className='nav-item fw-normal col p-0' key={i}>
              <NavLink
                replace={replace}
                to={{ pathname: d.pathname, state: { prevPage } }}
                className={({ isActive }) => `nav-link h-100 py-2 ${vertical ? 'text-start' : 'text-center'} ${isActive ? 'active border-1 fw-bold' : 'border-2 fw-normal'} ${underline ? 'border-bottom' : ''} text-decoration-none`}
              >
                <span>{d.display}</span>
              </NavLink>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* TABLET/MOBILE */}
    <div className={`row mb-4 d-block d-${breakpoint}-none`}>
      <div className='col-12'>
        <div className='row'>
          <div className='form-group mb-2 col'>
            <select
              aria-label='tabs'
              className='form-select'
              onChange={(e) => navigate(e.target.value, { state: { prevPage }, replace })}
              value={location.pathname}
            >
              {tabs.map((d, i) => <option key={i} value={d.pathname}>{d.display}</option>)}
            </select>
          </div>
        </div>
      </div>
    </div>
  </>
)

Tabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  prevPage: PropTypes.string,
  breakpoint: PropTypes.string,
  vertical: PropTypes.bool,
  replace: PropTypes.bool,
  location: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  NavLink: PropTypes.elementType.isRequired,
  underline: PropTypes.bool
}

export default Tabs
